import { render, staticRenderFns } from "./InventoryInfo.vue?vue&type=template&id=21371e5c&scoped=true"
import script from "./InventoryInfo.vue?vue&type=script&lang=js"
export * from "./InventoryInfo.vue?vue&type=script&lang=js"
import style0 from "./InventoryInfo.vue?vue&type=style&index=0&id=21371e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21371e5c",
  null
  
)

export default component.exports